export default {
  tabs: {
    access: 'Dostęp',
    notification_preferences: 'Ustawienia powiadomień',
  },
  sections: {
    notification_preferences: {
      title: 'Ustawienia powiadomień',
      form: {
        has_voice_call_reminders: {
          label: 'Odbieraj automatyczne połączenia o oczekujących zamówieniach',
        },
        voice_reminders_phone_number: {
          label: 'Numer telefonu do odbierania połączeń',
        },
        has_whatsapp_notifications: {
          label: 'Wysyłaj powiadomienia (np. zamówienia wstrzymane) przez WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'Numer telefonu WhatsApp',
        },
        has_order_email_notifications: {
          label: 'Wysyłaj powiadomienia o zamówieniach e-mailem',
        },
        order_notifications_email: {
          label: 'Adres e-mail do przekazywania powiadomień o zamówieniach',
        },
      },
    },
    voice_calls: {
      title: 'Połączenia głosowe',
    },
    whats_app_notifications: {
      title: 'Powiadomienia WhatsApp',
    },
    order_email_notifications: {
      title: 'Powiadomienia e-mail o zamówieniach',
    },
    access_control: {
      title: 'Kontrola dostępu',
      form: {
        company_ids: {
          label: 'Może uzyskać dostęp do restauracji',
          tooltip: 'Zapewnia dostęp do następujących restauracji (dodatkowo do restauracji w tej samej marce)',
        },
      },
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
